
export default class Pwa {

    constructor() {
        this.updated = false     // This prop is used by the PWA Update Modal component. Don't change it!
        this.registerServiceWorker()
    }

    validBrowser() {     
        const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)
        if (!raw) {
            return false
        }
        const version = parseInt(raw[2], 10)
        return version >= 73
    }

    devMode() {
        return window.location.href.includes('http://socrates.test/')
    }
    
    standaloneMode() {
        return window.matchMedia('(display-mode: standalone)').matches
    }
    
    registerServiceWorker() {
        window.addEventListener('load', () => {
            'use strict';

            // Check if we are in the right Chrome version.
            if (!this.validBrowser()) {
                return
            }

            if ('serviceWorker' in navigator) {   

                // Registrer the Service Worker.
                navigator.serviceWorker.register(window.baseURL + '/sw.js')
                .then((registration) => {

                    // This client has no controller. This may happen after a fresh install or after a force reload.
                    if (navigator.serviceWorker.controller === null) {
                        navigator.serviceWorker.ready.then(() => {
                            registration.active.postMessage('claim');
                        });
                    }

                    // registration worked. We check for updates.
                    registration.addEventListener('updatefound', () => {
                        let newWorker = registration.installing
                        newWorker.addEventListener('statechange', () => {
                            if (newWorker.state == 'activated') {
                                this.updated = true
                            }
                        })
                    })
                }).catch((error) => {
                    
                    // Registration failed
                    console.log('Service Worker registration failed with ' + error);
                })
            }
        })
    }
}
